import { render, staticRenderFns } from "./CardLogoAndNumbers.vue?vue&type=template&id=6ca048e1&"
import script from "./CardLogoAndNumbers.vue?vue&type=script&lang=js&"
export * from "./CardLogoAndNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports